<template>
  <div class="record-wrapper" @click="$emit('click')">
    <img v-if="recordBlob" :src="recordBlob" class="preview-container record-blob" />
    <div v-else class="preview-container">
      <font-awesome-icon icon="fa-solid fa-eye-slash center" size="2x" />
      <div class="no-preview">{{ `No preview` + getDocumentType }}</div>
    </div>
    <div style="margin: 12px 8px">
      <div class="record-name single-line-text">{{ title }}</div>
      <div class="record-date">{{ date }}</div>
    </div>
  </div>
</template>

<script>
import Utils from '../utils/helpers'
import FontAwesomeIcon from '../component-library/font-awesome-icon.vue'

export default {
  name: 'RecordCell',
  props: {
    date: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    recordUrl: {
      type: String,
      default: ''
    },
    provider: {
      type: String,
      default: ''
    },
    sharingToken: {
      type: String,
      default: null
    },
    mimetype: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      recordBlob: ''
    }
  },
  created() {
    this.getBlob()
  },
  components: {
    FontAwesomeIcon
  },
  methods: {
    async getBlob() {
      {
        if (this.recordUrl) {
          this.recordBlob = await Utils.getImageBlob(this.recordUrl, this.sharingToken)
        }
      }
    }
  },
  computed: {
    getDocumentType() {
      return this.mimetype === 'application/xml' ? ' - click to download' : ''
    }
  }
}
</script>

<style>
.record-wrapper {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(18, 22, 84, 0.24);
  border-radius: 8px;
  cursor: pointer;
}

.record-wrapper:hover {
  box-shadow: 0px 2px 8px rgba(18, 22, 84, 0.15), 0px 4px 24px rgba(18, 22, 84, 0.15);
  border-radius: 8px;
}

.preview-container {
  border: 1px solid #e5e6ee;
  box-sizing: border-box;
  border-radius: 6px;
  width: auto;
  height: 167px;
  margin: 8px 8px 0px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  object-fit: fill;
}

.no-preview {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #9aa0a6;
  text-align: center;
}

.center {
  text-align: center;
  color: #8e909a;
}

.record-blob {
  padding: 0 8px;
}

.record-name {
  font-size: 14px;
  line-height: 22px;
  color: #161616;
  margin-bottom: 4px;
  font-weight: 400;
}

.record-date {
  font-size: 14px;
  line-height: 16px;
  color: #565963;
}

.single-line-text {
  flex-wrap: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
